import './product-support.scss';

import { DetailHandler } from '../../components/detail-handler/detail-handler';
import { SelectBox } from '../../components/form/select-box';

class ProductSupport {
    constructor (element, options) {
        this.$productSupport = element;
        this.$form = this.$productSupport.querySelector('[data-product-support="form"]');
        this.$select = this.$productSupport.querySelector('[data-product-support="select"]');
        this.$hiddenField = this.$productSupport.querySelector('[data-product-support="hidden-value"]');
        this.$submit = this.$productSupport.querySelector('[data-product-support="submit"]');

        this.detailHandler = new DetailHandler({
            initContent: options.initContent,
            $loader: options.loader
        });
    }

    init () {
        this.bindEvents();
        this.initSelect();
    }

    initSelect () {
        if (this.$select) {
            this.select = new SelectBox(this.$select);

            this.select.selectbox.on('selectr.change', () => {
                this.enableSubmit();
            });
        }
    }

    bindEvents () {
        if (this.$form) {
            this.$form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.onFormSubmit();
            });
        }
    }

    creatUri () {
        const baseUrl = this.$form.getAttribute('action');
        let key;
        let value;

        if (this.$select) {
            key = this.$select.getAttribute('name');
            value = this.select.selectbox.getValue();
        } else if (this.$hiddenField) {
            key = this.$hiddenField.getAttribute('name');
            value = this.$hiddenField.value;
        } else {
            return false;
        }

        if (value === undefined) {
            return false;
        }

        const getParameter = `?${key}=${value}`;
        return baseUrl + getParameter;
    }

    onFormSubmit () {
        const uri = this.creatUri();
        if (uri) {
            this.detailHandler.showDetail(this.$productSupport, uri);
        }
    }

    enableSubmit () {
        if (this.$submit) {
            this.$submit.disabled = false;
        }
    }
}

export { ProductSupport };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productSupportTeasers = $context.querySelectorAll('[data-product-support-teaser="root"]');

        if ($productSupportTeasers.length > 0) {
            for (let i = 0; i < $productSupportTeasers.length; i++) {
                const $productSupportTeaser = new ProductSupport($productSupportTeasers[i], {
                    loader: window.OPTIONS.loader,
                    initContent: window.initSupportContent
                });
                $productSupportTeaser.init();
            }
        }
    }
});
